import { useState } from 'react';
import { Box, FormControl, FormLabel, Stack, Text } from '@chakra-ui/react';
import { FaGlobeAmericas } from 'react-icons/fa';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const CallInclusionAppliesToField = ({
    options = [],
    darkMode,
    disableStackHeight,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const dropdownOptions = options.map((option) => ({
        id: option.value,
        name: option.label,
        type: option.type,
    }));
    return (
        <Field
            name="appliesTo"
            validate={(value) => {
                // Handle both array of option objects and array of primitive values
                const hasValues = Array.isArray(value) && value.length > 0;
                return !hasValues
                    ? 'At least one option must be selected.'
                    : undefined;
            }}>
            {({ form, meta }) => {
                const error = meta.error;
                const showError = meta.touched;
                let errorMsg = undefined;
                if (showError) {
                    const appliesToValues = form.values.appliesTo;
                    const hasValues =
                        Array.isArray(appliesToValues) &&
                        appliesToValues.length > 0;
                    if (!hasValues) {
                        errorMsg = 'At least one option must be selected.';
                    } else if (error) {
                        errorMsg = error;
                    }
                }
                return (
                    <FormControl
                        sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
                        isInvalid={!!errorMsg}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}>
                        <Stack
                            direction="row"
                            alignItems="flex-start"
                            sx={
                                disableStackHeight
                                    ? { width: '775px' }
                                    : stackStyling(true)
                            }
                            width="100%">
                            <Box>
                                <FormLabel sx={formLabelStyling(darkMode)}>
                                    Applies To{' '}
                                    <span style={{ color: '#e53e3e' }}>*</span>
                                </FormLabel>
                                <Text sx={descriptionStyling} maxWidth={250}>
                                    Select one or more rates this inclusion
                                    applies to.
                                </Text>
                            </Box>
                            <Box flex="1" minWidth="450px" height="auto">
                                <DropDown
                                    name="appliesTo"
                                    isMulti
                                    data={dropdownOptions}
                                    shownValue="name"
                                    alphabetical={false}
                                    width="100%"
                                    formatOptionLabel={(item) => (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={2}>
                                            {item.type ===
                                                'InternationalCallRate' && (
                                                <FaGlobeAmericas
                                                    aria-label="International rate"
                                                    title="International rate"
                                                />
                                            )}
                                            <Text as="span">{item.name}</Text>
                                        </Box>
                                    )}
                                    multiValue={
                                        Array.isArray(form.values.appliesTo)
                                            ? form.values.appliesTo.map(
                                                  (valueItem) =>
                                                      valueItem &&
                                                      typeof valueItem ===
                                                          'object' &&
                                                      valueItem.value !==
                                                          undefined
                                                          ? valueItem.value
                                                          : valueItem,
                                              )
                                            : []
                                    }
                                    placeholder="- Select Rates -"
                                    darkMode={darkMode}
                                    handleSelectChange={(ids) => {
                                        const selected = (ids || [])
                                            .map((id) =>
                                                options.find(
                                                    (option) =>
                                                        option.value === id,
                                                ),
                                            )
                                            .filter(Boolean);
                                        form.setFieldValue(
                                            'appliesTo',
                                            selected,
                                        );
                                        form.validateField('appliesTo');
                                    }}
                                />
                                {!!errorMsg && (
                                    <Text
                                        color="red.500"
                                        fontSize="xs"
                                        mt={1}
                                        textAlign="right">
                                        {errorMsg}
                                    </Text>
                                )}
                            </Box>
                            {isHovered && (
                                <FieldToolTip
                                    label="Select one or more rates."
                                    ariaLabel="call-inclusion-applies-to-tip"
                                    left="25px"
                                    top="25px"
                                />
                            )}
                        </Stack>
                    </FormControl>
                );
            }}
        </Field>
    );
};

export default CallInclusionAppliesToField;
